import { portConstants } from '../../_constants';
import { portService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const portActions = {
    getPorts,
    getPortById,
    createPort,
    updatePort,
    deletePorts,
    activation,
    getActivePorts,
    getIsActivePortsBranchOrigin,
    getIsActivePortsBranchDestination,
    branchWithPorts
};

function portFetching() { return { type: portConstants.PORT_FETCHING } }
function portFetched() { return { type: portConstants.PORT_FETCHED } }

function portSubmitting() { return { type: portConstants.PORT_SUBMITTING } }
function portSubmitted() { return { type: portConstants.PORT_SUBMITTED } }

function getPorts(skip, take, filter, search) {
    return dispatch => {
        dispatch(portFetching());
        dispatch(userActions.allowLeavePage());
        portService.getPorts(skip, take, filter, search)
            .then(
                ports => {
                    if (ports.length > 0) {
                        dispatch(success(ports));
                        dispatch(portFetched());
                    } else {
                        dispatch(portFetched());
                        dispatch(alertActions.warning(ports.message))
                    }
                },
                error => {
                    dispatch(portFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(ports) { return { type: portConstants.GET_PORTS, ports } }
}
function getPortById(id) {
    return dispatch => {
        dispatch(portFetching());
        dispatch(userActions.allowLeavePage());
        portService.getPortById(id)
            .then(
                port => {
                    dispatch(portFetched());
                    dispatch(success(port));
                },
                error => {
                    dispatch(portFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(port) { return { type: portConstants.GET_PORT_BY_ID, port } }
}
function createPort(payload) {
    return dispatch => {
        dispatch(portSubmitting());
        dispatch(userActions.notallowLeavePage());
        portService.createPort(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portSubmitted());
                    dispatch(alertActions.success('Port added successfully'))
                    window.location.href = '/master_data/ports';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updatePort(payload, id) {
    return dispatch => {
        dispatch(portSubmitting());
        dispatch(userActions.notallowLeavePage());
        portService.updatePort(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portSubmitted());
                    dispatch(alertActions.success('Port updated successfully'))
                    window.location.href = '/master_data/ports';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(portSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function deletePorts(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        portService.deletePorts(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Ports deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/ports';
                            break;
                        default:
                            dispatch(getPorts(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getPortById(id));
                            break;
                        default:
                            dispatch(getPorts(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        portService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getPortById(id));
                    dispatch(alertActions.success(isActive ? 'Port activated successfully' : 'Port deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getActivePorts() {
    return dispatch => {
        portService.getActivePorts()
            .then(
                activePorts => dispatch(success(activePorts)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(activePorts) { return { type: portConstants.GET_ACTIVE_PORTS, activePorts } }
}
function getIsActivePortsBranchOrigin(branchCode) {
    return dispatch => {
        // portService.getIsActivePortsBranch(branchCode)
        portService.branchWithPorts(branchCode)
            .then(
                originPorts => {
                    dispatch(success(originPorts))
                },
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(originPorts) { return { type: portConstants.GET_ACTIVE_PORTS_BRANCH_ORIGIN, originPorts } }
}
function getIsActivePortsBranchDestination(branchCode) {
    return dispatch => {
        // portService.getIsActivePortsBranch(branchCode)
        portService.branchWithPorts(branchCode)
            .then(
                destinationPorts => {
                    dispatch(success(destinationPorts))
                },
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(destinationPorts) { return { type: portConstants.GET_ACTIVE_PORTS_BRANCH_DESTINATION, destinationPorts } }
}
function branchWithPorts(branchCode) {
    return dispatch => {
        portService.branchWithPorts(branchCode)
            .then(
                portsBranch => dispatch(success(portsBranch)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(portsBranch) { return { type: portConstants.BRANCH_WITH_PORTS, portsBranch } }
}